<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns">
        <div class="column has-text-centered">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="lateTypes"
            v-model="selectedLateType"
          />
        </div>
      </div>
      <!-- preview -->
      <div class="columns">
        <div class="column" v-if="selectedLateType">
          <span>kašnjenje će biti označeno kao</span>
          <span
            ><b> {{ selectedLateType.name }}</b></span
          >
          <span> za zaposlenog</span>
          <span
            ><b> {{ employeeName }}</b
            >.</span
          >
        </div>
      </div>
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
            :disabled="isSaveAndCloseButtonDisabled"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportService from "../../services/report.service";
export default {
  name: "EditAbsence",

  components: {},

  props: {
    title: String,
    selectedDailyLog: Object,
    startDate: Date,
    endDate: Date,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      selectedLateType: null,
      isSaveAndCloseButtonDisabled: false,
      employeeName: "",
      lateTypes: [
        { id: 0, name: "KN kašnjenje neopravdano" },
        { id: 1, name: "KO kašnjenje opravdano" },
        // { id: 2, name: "NK Nije kašnjenje" },
      ],
    };
  },

  computed: {},

  mounted() {
    console.log(this.selectedDailyLog);

    // Get name
    this.employeeName = this.$store.state.general.employees.find(
      (e) => e.id == this.selectedDailyLog.employeeId
    ).name;

    console.log("Employee: ", this.employeeName);
  },

  updated() {},

  methods: {
    saveAndProceedButtonClicked() {},
    saveAndCloseButtonClicked() {
      let manualCorrection = {
        employeeId: this.selectedDailyLog.employeeId,
        correctionDate: this.selectedDailyLog.logDate,
        isLateJustified:
          this.selectedLateType.id === 1
            ? true
            : this.selectedLateType.id === 2
            ? null
            : false,
      };
      console.log("XXXX");
      console.log(manualCorrection);
      reportService.CreateManualCorrection(manualCorrection).then(() => {
        console.log(this.startDate);
        console.log(this.endDate);
        reportService
          .GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            this.selectedDailyLog.employeeId,
            null
          )
          .then((response) => {
            console.log("ovo");
            console.log(response);
            this.$emit("saveAndCloseClicked", this.selectedLateType);
          });
      });
    },
  },
};
</script>
